import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import Toolbar from 'components/toolbar'
import DirectoryFilterFields from './directory-filter-fields'
import { get, isEmpty, isEqual, mapValues } from 'lodash'
import { deepCount } from 'utils'
import classnames from 'classnames'

const propTypes = {
  filterOptions: Types.directoryFilterOptions.isRequired,
  applyFilter: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
  appliedFilters: Types.directoryFilterSelections.isRequired,
  selectedFilters: Types.directoryFilterSelections.isRequired,
}

const defaultProps = {}

function DirectoryFilterToolbar({ appliedFilters, selectedFilters, ...rest }) {
  const isFilterUnchanged = useCallback(
    (filterName) =>
      isEqual(
        get(appliedFilters, filterName),
        get(selectedFilters, filterName)
      ),
    [appliedFilters, selectedFilters]
  )

  const isFilterEmpty = useCallback(
    (filterName) => isEmpty(get(selectedFilters, filterName)),
    [selectedFilters]
  )

  const appliedFilterCounts = useMemo(
    () => mapValues(appliedFilters, deepCount),
    [appliedFilters]
  )

  const getAppliedFilterCount = useCallback(
    (filterName) => get(appliedFilterCounts, filterName),
    [appliedFilterCounts]
  )

  const [openFilterId, setOpenFilterId] = useState(null)

  const closeFilter = useCallback(
    (id) => {
      if (id !== openFilterId) return
      return setOpenFilterId(null)
    },
    [openFilterId]
  )

  return (
    <div
      className={classnames('filter-content', {
        'filter-open': !!openFilterId,
      })}
    >
      <Toolbar
        className="filter-wrapper filters"
        aria-label="Directory Filtering"
        aria-controls="directory-profiles"
        data-cy="educator-search"
      >
        <p>
          <strong>Filter By:</strong>
        </p>
        <DirectoryFilterFields
          getAppliedFilterCount={getAppliedFilterCount}
          isFilterEmpty={isFilterEmpty}
          isFilterUnchanged={isFilterUnchanged}
          openFilterId={openFilterId}
          openFilter={setOpenFilterId}
          closeFilter={closeFilter}
          {...rest}
        />
      </Toolbar>
    </div>
  )
}

DirectoryFilterToolbar.propTypes = propTypes
DirectoryFilterToolbar.defaultProps = defaultProps

export default DirectoryFilterToolbar
